import { CountryNames, ORGANIZATION_COUNTRY_MAP } from "../enums/country";
export const getSignupCountryFromCountryCode = (countryCode) => {
    if (!countryCode) {
        return undefined;
    }
    const entry = Object.values(ORGANIZATION_COUNTRY_MAP).find((mapping) => mapping.countryCode === countryCode);
    return entry?.countryName ?? "NOT_SUPPORTED_COUNTRY";
};
export const isEinSignupCountry = (country) => {
    return country !== CountryNames.Ireland;
};
export const shouldSearchNonprofitRegisterAtSignup = (country, isTaxExemptChoice) => isEinSignupCountry(country) && (isTaxExemptChoice || country === CountryNames.Germany);
export const getEligibilityChoiceContent = (country) => {
    const isUS = country === CountryNames.UnitedStates;
    const isGB = country === CountryNames.UnitedKingdom;
    const isIE = country === CountryNames.Ireland;
    const isDE = country === CountryNames.Germany;
    const isAuNz = country === CountryNames.Australia || country === CountryNames.NewZealand;
    return {
        displayTaxExemptChoice: !isAuNz && !isDE,
        displayOtherNonProfitChoice: !isIE,
        taxExemptTitleKey: isGB
            ? "signup.eligibilityCriteriaTaxExempt.GB"
            : isIE
                ? "signup.eligibilityCriteriaTaxExempt.IE"
                : isDE
                    ? "signup.eligibilityCriteriaTaxExempt.DE"
                    : "signup.eligibilityCriteriaTaxExempt",
        taxExemptDescriptionKey: isUS
            ? "signup.eligibilityCriteriaTaxExemptDescription.US"
            : isGB
                ? "signup.eligibilityCriteriaTaxExemptDescription.GB"
                : isIE
                    ? "signup.eligibilityCriteriaTaxExemptDescription.IE"
                    : isDE
                        ? "signup.eligibilityCriteriaTaxExemptDescription.DE"
                        : "signup.eligibilityCriteriaTaxExemptDescription.Canada",
        otherNonProfitTitleKey: isGB
            ? "signup.eligibilityCriteriaOtherNonProfit.GB"
            : isDE
                ? "signup.eligibilityCriteriaOtherNonProfit.DE"
                : isAuNz
                    ? "signup.eligibilityCriteriaTaxExempt.AuNz"
                    : "signup.eligibilityCriteriaOtherNonProfit",
        otherNonProfitDescriptionKey: isUS
            ? "signup.eligibilityCriteriaOtherNonProfitDescription.US"
            : isGB
                ? "signup.eligibilityCriteriaOtherNonProfitDescription.GB"
                : isDE
                    ? "signup.eligibilityCriteriaOtherNonProfitDescription.DE"
                    : isAuNz
                        ? "signup.eligibilityCriteriaTaxExemptDescription.AuNz"
                        : "signup.eligibilityCriteriaOtherNonProfitDescription.Canada",
    };
};
